export default [
  {
    text: 'crintGroups.table.name',
    value: 'name',
  },
  {
    text: 'printGroups.table.active',
    value: 'isActive',
    type: 'boolean',
  },
];
